import React, { useEffect, useState, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { authActions, myAccountActions } from "../../../_store";
import translations from '../../../config/TranslateFile.jsx'
import { EventLog } from "../../common/EventLog/EventLog";
import { getStoredValue, removeStoredValue, setStoredValue } from "../../../_helpers/storagehelper.js";
import useTransactionPending from "../../../hooks/useTransactionPending.jsx";

function DropdownProfile() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setIsSaveTriggered } = useTransactionPending();
  const myAccountDetails = useSelector(
    (state) => state.myAccount.LoadPublicUserDetails
  );
  const currentLang = translations();
  useEffect(() => {
    dispatch(myAccountActions.LoadPublicUserDetails());
  }, [dispatch]);

  const logout = () => {
    handlemenuClick();
    const isFromAdmin = sessionStorage.getItem("from") ? true : false
    if (isFromAdmin) return;
    localStorage.setItem("issmanuallogout", true);
    dispatch(authActions.logout());
    const infoMessage = "Public User logout into the Account";
    const redirectURL = "/public/Login";
    const Response = '---';
    const Status = "Logout Successfully";
    EventLog(dispatch, infoMessage, redirectURL, Response, Status)
    removeStoredValue("lang"); // Remove Spanish setting if exists
    setStoredValue("lang", "en"); // Resetting to English
    navigate("/public/Login"); // Add leading '/'
  };

  const handlemenuClick = () => {
    const savedtransactionPending = getStoredValue("transactionPending");
    if (savedtransactionPending != null) {
      setIsSaveTriggered(true);
    }
  }


  return (

    <div className="navbar-item navbar-user dropdown pe-3">

      <a
        href="#/"
        className="navbar-link dropdown-toggle d-flex align-items-center profile-link"
        data-bs-toggle="dropdown"
      >
        <div className="image image-icon bg-gray-800 text-gray-600">
          <i className="fa fa-user"></i>
        </div>

        <span>
          <p className="mb-0 font-size-14"> {currentLang?.welcome}</p>
          <span className="d-md-inline fw-600 text-default-red break-words">{myAccountDetails?.UserName}</span>
        </span>
      </a>
      <div className="dropdown-menu dropdown-menu-end me-1">
        <Link to="/public/MyAccount" onClick={() => { handlemenuClick() }} className="dropdown-item me-1">
          <i className="fa fa-user me-2"></i>
          {currentLang?.MyAccount}
        </Link>

        <span onClick={logout} className="dropdown-item">
          <i className="fa fa-sign-out me-2"></i>
          {currentLang?.Logout}
        </span>
      </div>
    </div>
  );
}

export default DropdownProfile;
